import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

const procedimientos = [
  "Firma de consentimiento Informado",
  "Criterios de Inclusión",
  "Criterios de Exclusión",
  "Criterios de Eliminación",
  "Historia Clínica",
  "Signos Vitales",
  "Inicio al tratamiento",
  "Seguimiento del tratamiento",
  "Revisión y diario/paciente",
  "Entrega de Vale de laboratorio",
  "Revisión de resultados de laboratorio",
  "Determinar índice de HOMA",
  "Medicamentos Concomitantes",
  "Eventos Adversos",
  "Porcentaje de Grasa"
];

const visitas = [
  "Visita 0 Aleatorización",
  "Visita 1 Semana 1 Seguimiento",
  "Visita 2 1 mes Seguimiento",
  "Visita 3 3 meses Fin del estudio"
];

const links = {
  "Firma de consentimiento Informado": {
    "Visita 0 Aleatorización": "/ConcentimientoInformado"
  },
  "Criterios de Inclusión": {
    "Visita 0 Aleatorización": "/CriteriosE"
  },
  "Criterios de Exclusión": {
    "Visita 0 Aleatorización": "/CriteriosI"
  },
  "Criterios de Eliminación": {
    "Visita 0 Aleatorización": "/CriteriosEliminacion"
  },
  "Historia Clínica": {
    "Visita 0 Aleatorización": "/HistoriaClinica"
  },
  "Signos Vitales": {
    "Visita 0 Aleatorización": "/Signos_Vitales",
    "Visita 1 Semana 1 Seguimiento": "/Signos_Vitales",
    "Visita 2 1 mes Seguimiento": "/Signos_Vitales",
    "Visita 3 3 meses Fin del estudio": "/Signos_Vitales"
  },
  "Inicio al tratamiento": {
    "Visita 0 Aleatorización": "/MedidasAntropomorficas"
  },
  "Seguimiento del tratamiento": {
    "Visita 1 Semana 1 Seguimiento": "/Seguimiento",
    "Visita 2 1 mes Seguimiento": "/Seguimiento",
    "Visita 3 3 meses Fin del estudio": "/Seguimiento"
  },
  "Revisión y diario/paciente": {
    "Visita 1 Semana 1 Seguimiento": "/InicioTratamiento",
    "Visita 2 1 mes Seguimiento": "/InicioTratamiento",
    "Visita 3 3 meses Fin del estudio": "/InicioTratamiento"
  },
  "Entrega de Vale de laboratorio": {
    "Visita 0 Aleatorización": "/SeguimientoTratamiento"
  },
  "Revisión de resultados de laboratorio": {
    "Visita 1 Semana 1 Seguimiento": "/Archivos",
    "Visita 2 1 mes Seguimiento": "/Archivos",
    "Visita 3 3 meses Fin del estudio": "/Archivos"
  },
  "Determinar índice de HOMA": {
    "Visita 0 Aleatorización": "/IndiceHoma"
  },
  "Porcentaje de Grasa": {
    "Visita 0 Aleatorización": "/PorcentajeGrasa",
    "Visita 1 Semana 1 Seguimiento": "/PorcentajeGrasa",
    "Visita 2 1 mes Seguimiento": "/PorcentajeGrasa",
    "Visita 3 3 meses Fin del estudio": "/PorcentajeGrasa"
  },
  "Medicamentos Concomitantes": {
    "Visita 0 Aleatorización": "/MedicamentosConcomitantes",
    "Visita 1 Semana 1 Seguimiento": "/MedicamentosConcomitantes",
    "Visita 2 1 mes Seguimiento": "/MedicamentosConcomitantes",
    "Visita 3 3 meses Fin del estudio": "/MedicamentosConcomitantes"
  },
  "Eventos Adversos": {
    "Visita 1 Semana 1 Seguimiento": "/EventosAdversos",
    "Visita 2 1 mes Seguimiento": "/EventosAdversos",
    "Visita 3 3 meses Fin del estudio": "/EventosAdversos"
  },
  "Estudios": { "Visita 0 Aleatorización": "/Archivos" },
};

// 🔹 Procedimientos que requieren también el parámetro visita
const requiereVisita = ["Inicio al tratamiento","Entrega de Vale de laboratorio","Medidas antropomórficas","Seguimiento del tratamiento","Revisión y diario/paciente","Medidas antropomórficas", "Signos Vitales", "Medicamentos Concomitantes","Eventos Adversos","Porcentaje de Grasa"];

const TablaProcedimientos = () => {
  const { idPaciente } = useParams();
  const navigate = useNavigate();

const [botonColors, setBotonColors] = useState({
  FirmaConsentimiento: "red",
  CriteriosInclusion: "red",
  CriteriosExclusion: "red",
  CriteriosEliminacion: "red",
  HistoriaClinica: "red",
  SignosVitales: {},
  MedicamentosConcomitantes: {},
  EventosAdversos: {},
  Estudios: "red",
  InicioTratamiento: {},
  SeguimientoTratamiento: {},
  RevisionDiario: {},
  ValeLaboratorio: {},   // 🔹 objeto, no string
  RevisionLaboratorio: {}, // 🔹 objeto
  IndiceHoma: {},        // 🔹 objeto
});



  const determinarColor = (completo, parcial) => {
    if (completo) return "green";
    if (parcial) return "yellow";
    return "red";
  };

  const normalizaSN = (v) => {
    if (v === true) return "SI";
    if (v === false) return "NO";
    if (typeof v === "string") {
      const t = v.trim().toUpperCase();
      if (t === "SI" || t === "SÍ") return "SI";
      if (t === "NO") return "NO";
    }
    return null;
  };

  const extraeRespuestasSN = (data) => {
    const base =
      (Array.isArray(data?.respuestas) && data.respuestas) ||
      (Array.isArray(data?.preguntas) && data.preguntas) ||
      (Array.isArray(data) && data) ||
      [];

    return base
      .map((x) => {
        if (typeof x === "string" || typeof x === "boolean") return normalizaSN(x);
        if (x && typeof x === "object") {
          return normalizaSN(x.respuesta ?? x.valor ?? x.answer ?? x.checked);
        }
        return null;
      })
      .filter((v) => v === "SI" || v === "NO");
  };

  const ningunContestada = (resp) => resp.length === 0;

  const colorInclusion = (respuestas, totalEsperado) => {
    if (ningunContestada(respuestas)) return "red";
    const todasSi = respuestas.every((r) => r === "SI");
    const algunaNo = respuestas.some((r) => r === "NO");
    const incompleto = totalEsperado ? respuestas.length < totalEsperado : false;
    if (todasSi && !incompleto) return "green";
    if (algunaNo || incompleto) return "yellow";
    return "yellow";
  };

  const colorExclusion = (respuestas, totalEsperado) => {
    if (ningunContestada(respuestas)) return "red";
    const todasNo = respuestas.every((r) => r === "NO");
    const algunaSi = respuestas.some((r) => r === "SI");
    const incompleto = totalEsperado ? respuestas.length < totalEsperado : false;
    if (todasNo && !incompleto) return "green";
    if (algunaSi || incompleto) return "yellow";
    return "yellow";
  };

  const colorConsentimiento = (data) => {
    if (typeof data?.respuesta_correcta === "boolean") {
      return data.respuesta_correcta ? "green" : "yellow";
    }
    const respuestas = extraeRespuestasSN(data);
    if (ningunContestada(respuestas)) return "red";
    return "yellow";
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/Login");
      return;
    }
    if (!idPaciente) return;

    const fetchConsentimiento = async () => {
      try {
        const res = await fetch(`https://api.weareinfinite.mx/form/verifyconsentimiento/${idPaciente}`);
        const data = await res.json();
        setBotonColors((prev) => ({
          ...prev,
          FirmaConsentimiento: colorConsentimiento(data),
        }));
      } catch {
        setBotonColors((prev) => ({ ...prev, FirmaConsentimiento: "red" }));
      }
    };

    const fetchCriteriosInclusion = async () => {
      try {
        const res = await fetch(`https://api.weareinfinite.mx/form/verifycriterios_inclusion/${idPaciente}`);
        if (res.status === 400 || res.status === 404) {
          setBotonColors((prev) => ({ ...prev, CriteriosInclusion: "red" }));
          return;
        }
        const data = await res.json();
        if (data.respuesta_correcta === true) {
          setBotonColors((prev) => ({ ...prev, CriteriosInclusion: "green" }));
        } else if (data.respuesta_correcta === false) {
          setBotonColors((prev) => ({ ...prev, CriteriosInclusion: "yellow" }));
        } else {
          setBotonColors((prev) => ({ ...prev, CriteriosInclusion: "red" }));
        }
      } catch {
        setBotonColors((prev) => ({ ...prev, CriteriosInclusion: "red" }));
      }
    };

    const fetchCriteriosExclusion = async () => {
      try {
        const res = await fetch(`https://api.weareinfinite.mx/form/criterios_exclusionV/${idPaciente}`);
        if (res.status === 400 || res.status === 404) {
          setBotonColors((prev) => ({ ...prev, CriteriosExclusion: "red" }));
          return;
        }
        const data = await res.json();
        if (data.respuesta_correcta === true) {
          setBotonColors((prev) => ({ ...prev, CriteriosExclusion: "green" }));
        } else if (data.respuesta_correcta === false) {
          setBotonColors((prev) => ({ ...prev, CriteriosExclusion: "yellow" }));
        } else {
          setBotonColors((prev) => ({ ...prev, CriteriosExclusion: "red" }));
        }
      } catch {
        setBotonColors((prev) => ({ ...prev, CriteriosExclusion: "red" }));
      }
    };

   const fetchCriteriosEliminacion = async () => {
  try {
    const res = await fetch(`https://api.weareinfinite.mx/form/criterios_eliminacion/verificar/${idPaciente}`);
    if (res.status === 400 || res.status === 404) {
      setBotonColors((prev) => ({ ...prev, CriteriosEliminacion: "red" }));
      return;
    }

    const data = await res.json();

    if (data.respuesta_correcta === true) {
      setBotonColors((prev) => ({ ...prev, CriteriosEliminacion: "green" }));
    } else if (data.respuesta_correcta === false) {
      setBotonColors((prev) => ({ ...prev, CriteriosEliminacion: "yellow" }));
    } else {
      setBotonColors((prev) => ({ ...prev, CriteriosEliminacion: "red" }));
    } 
  } catch (error) {
    setBotonColors((prev) => ({ ...prev, CriteriosEliminacion: "red" }));
  }
};


 const fetchSignosPorVisita = async () => {
    try {
      const nuevosColores = {};
      for (let i = 0; i < visitas.length; i++) {
        const visita = `v${i}`; // para usar en estado
        const visitaNombre = visitas[i]; // nombre completo de la visita
        // Construimos la ruta con idPaciente y visitaClave (puedes ajustar visitaClave si la API requiere otro formato)
        const res = await fetch(`https://api.weareinfinite.mx/form/signos/paciente/${idPaciente}/${visita}`);
        if (!res.ok) {
          nuevosColores[visita] = "red";
          continue;
        }
        const data = await res.json();

        // Aquí asumimos que data es un array de signos
        const todasContestadas = data.length > 0;
        const algunFueraRango = data.some((signo) =>
          Object.keys(signo).some((key) => key.includes("_fuera_de_rango") && signo[key])
        );

        nuevosColores[visita] = determinarColor(todasContestadas && !algunFueraRango, todasContestadas || algunFueraRango);
      }

      setBotonColors((prev) => ({
        ...prev,
        SignosVitales: nuevosColores,
      }));
    } catch (error) {
      // Si falla todo, ponemos todas en rojo
      const fallbackColors = {};
      for (let i = 0; i < visitas.length; i++) {
        fallbackColors[`v${i}`] = "red";
      }
      setBotonColors((prev) => ({
        ...prev,
        SignosVitales: fallbackColors,
      }));
    }
  };
    const fetchHistoria = async () => {
      try {
        const res = await fetch(`https://api.weareinfinite.mx/form/historia_clinicaVerify/${idPaciente}`);
        const data = await res.json();
        setBotonColors((prev) => ({
          ...prev,
          HistoriaClinica: determinarColor(data.todas_contestadas, !data.todas_contestadas && data.algunas),
        }));
      } catch {
        setBotonColors((prev) => ({ ...prev, HistoriaClinica: "red" }));
      }
    };

const fetchMedicamentosConcomitantesPorVisita = async () => {
  try {
    const nuevosColores = {};
    for (let i = 0; i < visitas.length; i++) {
      const visita = `v${i}`;
      const res = await fetch(`https://api.weareinfinite.mx/form/medicamentos_concomitantesV/${idPaciente}/${visita}`);
      if (!res.ok) {
        nuevosColores[visita] = "red";
        continue;
      }
      const data = await res.json();
      const completo = data?.respuestas_completas;
      const parcial = data?.algunas;
      nuevosColores[visita] = determinarColor(completo, parcial);
    }

    setBotonColors(prev => ({
      ...prev,
      MedicamentosConcomitantes: nuevosColores,
    }));
  } catch {
    const fallbackColors = {};
    for (let i = 0; i < visitas.length; i++) {
      fallbackColors[`v${i}`] = "red";
    }
    setBotonColors(prev => ({
      ...prev,
      MedicamentosConcomitantes: fallbackColors,
    }));
  }
};

// 🔹 Inicio de tratamiento
const fetchInicioTratamiento = async () => {
  try {
    const nuevosColores = {};
    for (let i = 0; i < visitas.length; i++) {
      const visita = `v${i}`;
      const res = await fetch(`https://api.weareinfinite.mx/form/formulariosVerify/${idPaciente}/inicio_tratamiento_visita_${visita}`);

      // ⛔ Si la respuesta da 400 o 404, lo marcamos como rojo directamente
      if (res.status === 400 || res.status === 404) {
        nuevosColores[visita] = "red";
        continue;
      }

      const data = await res.json();

      // ✅ True → verde | ❌ False → amarillo | ❓ Otro → rojo
      if (data?.respuesta_correcta === true) {
        nuevosColores[visita] = "green";
      } else if (data?.respuesta_correcta === false) {
        nuevosColores[visita] = "yellow";
      } else {
        nuevosColores[visita] = "red";
      }
    }

    setBotonColors(prev => ({
      ...prev,
      InicioTratamiento: nuevosColores,
    }));
  } catch {
    // Error general: marcamos todas como rojo
    const fallbackColors = {};
    for (let i = 0; i < visitas.length; i++) {
      fallbackColors[`v${i}`] = "red";
    }
    setBotonColors(prev => ({
      ...prev,
      InicioTratamiento: fallbackColors,
    }));
  }
};

const fetchSeguimientoTratamiento = async () => {
  try {
    const nuevosColores = {};
    for (let i = 0; i < visitas.length; i++) {
      const visita = `v${i}`;
      const res = await fetch(`https://api.weareinfinite.mx/form/formulariosVerify/${idPaciente}/seguimiento_visita_${visita}`);

      // ⛔ Si la respuesta da 400 o 404, lo marcamos como rojo directamente
      if (res.status === 400 || res.status === 404) {
        nuevosColores[visita] = "red";
        continue;
      }

      const data = await res.json();

      // ✅ True → verde | ❌ False → amarillo | ❓ Otro → rojo
      if (data?.respuesta_correcta === true) {
        nuevosColores[visita] = "green";
      } else if (data?.respuesta_correcta === false) {
        nuevosColores[visita] = "yellow";
      } else {
        nuevosColores[visita] = "red";
      }
    }

    setBotonColors(prev => ({
      ...prev,
      SeguimientoTratamiento: nuevosColores,
    }));
  } catch {
    const fallbackColors = {};
    for (let i = 0; i < visitas.length; i++) {
      fallbackColors[`v${i}`] = "red";
    }
    setBotonColors(prev => ({
      ...prev,
      SeguimientoTratamiento: fallbackColors,
    }));
  }
};

const fetchRevisionDiario = async () => {
  try {
    const nuevosColores = {};
    for (let i = 0; i < visitas.length; i++) {
      const visita = `v${i}`;
      const res = await fetch(`https://api.weareinfinite.mx/form/formulariosVerify/${idPaciente}/inicio_tratamiento_visita_${visita}`);
     
      if (res.status === 400 || res.status === 404) {
        nuevosColores[visita] = "red";
        continue;
      }

      const data = await res.json();
      if (data?.respuesta_correcta === true) {
        nuevosColores[visita] = "green";
      } else if (data?.respuesta_correcta === false) {
        nuevosColores[visita] = "yellow";
      } else {
        nuevosColores[visita] = "red";
      }
    }

    setBotonColors(prev => ({
      ...prev,
      RevisionDiario: nuevosColores,
    }));
  } catch {
    const fallbackColors = {};
    for (let i = 0; i < visitas.length; i++) {
      fallbackColors[`v${i}`] = "red";
    }
    setBotonColors(prev => ({
      ...prev,
      RevisionDiario: fallbackColors,
    }));
  }
};

const fetchValeLaboratorio = async () => {
  try {
    const nuevosColores = {};
    for (let i = 0; i < visitas.length; i++) {
      const visita = `v${i}`;
      const res = await fetch(`https://api.weareinfinite.mx/form/formulariosVerify/${idPaciente}/seguimiento_tratamiento_visita_${visita}`);
      
      if (res.status === 400 || res.status === 404) {
        nuevosColores[visita] = "red";
        continue;
      }

      const data = await res.json();
      if (data?.respuesta_correcta === true) {
        nuevosColores[visita] = "green";
      } else if (data?.respuesta_correcta === false) {
        nuevosColores[visita] = "yellow";
      } else {
        nuevosColores[visita] = "red";
      }
    }
    setBotonColors(prev => ({
      ...prev,
      ValeLaboratorio: nuevosColores,
    }));
  } catch {
    const fallbackColors = {};
    for (let i = 0; i < visitas.length; i++) {
      fallbackColors[`v${i}`] = "red";
    }
    setBotonColors(prev => ({
      ...prev,
      ValeLaboratorio: fallbackColors,
    }));
  }
};

const fetchIndiceHoma = async () => {
  try {
    const nuevosColores = {};
    for (let i = 0; i < visitas.length; i++) {
      const visita = `v${i}`;
      const res = await fetch(`https://api.weareinfinite.mx/form/formulariosVerify/${idPaciente}/indice_homa`);
      if (!res.ok) {
        nuevosColores[visita] = "red";
        continue;
      }
      const data = await res.json();
      if (data?.respuesta === true) {
        nuevosColores[visita] = "green";
      } else if (data?.respuesta === false) {
        nuevosColores[visita] = "yellow";
      } else {
        nuevosColores[visita] = "red";
      }
    }
    setBotonColors(prev => ({ ...prev, IndiceHoma: nuevosColores }));
  } catch (error) {
    console.error("Error al obtener índice HOMA:", error);
    const fallbackColors = {};
    for (let i = 0; i < visitas.length; i++) {
      fallbackColors[`v${i}`] = "red";
    }
    setBotonColors(prev => ({ ...prev, IndiceHoma: fallbackColors }));
  }
};

const fetchPorcentajeGrasa = async () => {
  try {
    const promesas = visitas.map((_, i) =>
      fetch(`https://api.weareinfinite.mx/form/formulariosVerify/${idPaciente}/porcentaje_grasa_visita_v${i}`)
        .then(res => res.ok ? res.json() : null)
        .then(data => {
          if (!data) return "red";
          if (data?.respuesta === true) return "green";
          if (data?.respuesta === false) return "yellow";
          return "red";
        })
        .catch(() => "red")
    );

    const resultados = await Promise.all(promesas);
    const nuevosColores = {};
    resultados.forEach((color, i) => {
      nuevosColores[`v${i}`] = color;
    });

    setBotonColors(prev => ({ ...prev, PorcentajeGrasa: nuevosColores }));
  } catch (error) {
    console.error("Error en Porcentaje de Grasa:", error);
    const fallbackColors = {};
    for (let i = 0; i < visitas.length; i++) {
      fallbackColors[`v${i}`] = "red";
    }
    setBotonColors(prev => ({ ...prev, PorcentajeGrasa: fallbackColors }));
  }
};



const fetchEventosAdversosPorVisita = async () => {
  try {
    const nuevosColores = {};
    for (let i = 0; i < visitas.length; i++) {
      const visita = `v${i}`;
      const res = await fetch(`https://api.weareinfinite.mx/form/verificar_evento/${idPaciente}/${visita}`);
      if (!res.ok) {
        nuevosColores[visita] = "red";
        continue;
      }
      const data = await res.json();
      const completo = data?.respuestas_completas;
      const parcial = data?.algunas;
      nuevosColores[visita] = determinarColor(completo, parcial);
    }

    setBotonColors(prev => ({
      ...prev,
      EventosAdversos: nuevosColores,
    }));
  } catch {
    const fallbackColors = {};
    for (let i = 0; i < visitas.length; i++) {
      fallbackColors[`v${i}`] = "red";
    }
    setBotonColors(prev => ({
      ...prev,
      EventosAdversos: fallbackColors,
    }));
  }
};



    const fetchEstudios = async () => {
      try {
        setBotonColors((prev) => ({ ...prev, Estudios: "transparent" }));
      } catch {
        setBotonColors((prev) => ({ ...prev, Estudios: "red" }));
      }
    };

    // 🔹 Ejecutar todos los fetch
    fetchConsentimiento();
    fetchCriteriosInclusion();
    fetchCriteriosExclusion();
    fetchCriteriosEliminacion(); // ✅
    fetchSignosPorVisita();
    fetchHistoria();
    fetchMedicamentosConcomitantesPorVisita();
    fetchEventosAdversosPorVisita();
    fetchEstudios();
    fetchInicioTratamiento();
    fetchSeguimientoTratamiento();
    fetchRevisionDiario();
    fetchValeLaboratorio();
    fetchIndiceHoma();
    fetchPorcentajeGrasa();
  }, [idPaciente, navigate]);

const handleClick = (link, proc, visitaIdx) => {
    if (link !== "#") {
      if (requiereVisita.includes(proc)) {
        // ejemplo: /MedidasAntropomorficas/003/v3
        navigate(`${link}/${idPaciente}/v${visitaIdx}`);
      } else {
        // rutas normales
        navigate(`${link}/${idPaciente}`);
      }
    } else {
      alert("No hay ruta disponible para esta combinación de procedimiento y visita.");
    }
  };

return (
    <div className="container" style={{ overflowX: "auto" }}>
      <h2>Tabla de Procedimientos</h2>
      <table>
        <thead>
          <tr>
            <th>Procedimiento</th>
            {visitas.map((v, i) => (
              <th key={i}>{v}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {procedimientos.map((proc, i) => (
            <tr key={i}>
              <td>{proc}</td>
              {visitas.map((visita, j) => {
                const link = links[proc]?.[visita] || "#";

                // Para signos vitales usamos el color específico por visita
                let backgroundColor = "initial";
                if (proc === "Firma de consentimiento Informado") {
                  backgroundColor = botonColors.FirmaConsentimiento;
                } else if (proc === "Signos Vitales") {
                  backgroundColor = botonColors.SignosVitales[`v${j}`] || "red";
                } else if (proc === "Criterios de Inclusión") {
                  backgroundColor = botonColors.CriteriosInclusion;
                } else if (proc === "Criterios de Exclusión") {
                  backgroundColor = botonColors.CriteriosExclusion;
                } else if (proc === "Criterios de Eliminación") {
                  backgroundColor = botonColors.CriteriosEliminacion;
                } else if (proc === "Historia Clínica") {
                  backgroundColor = botonColors.HistoriaClinica;
}
else if (proc === "Medicamentos Concomitantes") {
  backgroundColor = botonColors.MedicamentosConcomitantes?.[`v${j}`] || "red";
}
else if (proc === "Eventos Adversos") {
  backgroundColor = botonColors.EventosAdversos?.[`v${j}`] || "red";
                } else if (proc === "Estudios") {
                  backgroundColor = botonColors.Estudios;
                }
                else if (proc === "Eventos Adversos") {
  backgroundColor = botonColors.EventosAdversos?.[`v${j}`] || "red";
} else if (proc === "Inicio al tratamiento") {
  backgroundColor = botonColors.InicioTratamiento?.[`v${j}`] || "red";
} else if (proc === "Seguimiento del tratamiento") {
  backgroundColor = botonColors.SeguimientoTratamiento?.[`v${j}`] || "red";
} else if (proc === "Revisión y diario/paciente") {
  backgroundColor = botonColors.RevisionDiario?.[`v${j}`] || "red";
}  else if (proc === "Entrega de Vale de laboratorio") {
  backgroundColor = botonColors.ValeLaboratorio?.[`v${j}`] || "red";
} else if (proc === "Determinar índice de HOMA") {
  backgroundColor = botonColors.IndiceHoma?.[`v${j}`] || "red";
}else if (proc === "Porcentaje de Grasa") {
  backgroundColor = botonColors.PorcentajeGrasa?.[`v${j}`] || "red";
}


                return (
                  <td key={j} style={{ textAlign: "center" }}>
                    {link !== "#" ? (
                      <button
                        className="boton-celda"
                        style={{
                          backgroundColor,
                          padding: "5px 10px",
                          borderRadius: "4px",
                          cursor: "pointer",
                        }}
                        onClick={() => handleClick(link, proc, j)}
                      >
                        <span role="img" aria-label="Formulario">📝</span>
                      </button>
                    ) : (
                      <button
                        className="boton-celda"
                        style={{
                          backgroundColor: "initial",
                          border: "1px solid #ccc",
                          width: "30px",
                          height: "30px",
                        }}
                        disabled
                      />
                    )}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
      <div style={{ marginTop: "20px", textAlign: "center" }}>
  <button
    onClick={() => navigate("/Exel/SMET-40429")}
    style={{
      backgroundColor: "#909899ff",
      color: "white",
      padding: "8px 12px",
      fontSize: "14px",
      borderRadius: "6px",
      cursor: "pointer",
      border: "none",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "6px",
    }}
  >
    🏠 Inicio
  </button>
</div>
    </div>
  );
};

export default TablaProcedimientos;
